var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{class:!_vm.$vuetify.breakpoint.mdAndUp ? 'px-2 footer-text' : 'footer-text',attrs:{"xs12":""}},[_vm._v("\n "+_vm._s(_vm.$i18n.t('footerMessage'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }